'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _money = require('../../helpers/money');

var Money = _interopRequireWildcard(_money);

var _FormInput = require('../FormInput');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromotionCode = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { flash: state.flash };
}), _dec3 = (0, _reactI18next.translate)(), _dec4 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PromotionCode, _React$Component);

  function PromotionCode(props, context) {
    (0, _classCallCheck3.default)(this, PromotionCode);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PromotionCode.__proto__ || (0, _getPrototypeOf2.default)(PromotionCode)).call(this, props, context));

    _this.state = {
      applyCouponButtonDisabled: true
    };
    return _this;
  }

  (0, _createClass3.default)(PromotionCode, [{
    key: 'handleInputReturn',
    value: function handleInputReturn(e) {
      e.preventDefault();
      this.props.onApply(e);
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      this.setState({
        applyCouponButtonDisabled: !e.target.value
      });
    }
  }, {
    key: 'additionalStyles',
    value: function additionalStyles() {
      if (this.props.flash.message) {
        return 'a-input--error';
      }

      return 'a-input--inline';
    }
  }, {
    key: 'renderError',
    value: function renderError(name) {
      return _react2.default.createElement(
        'div',
        { styleName: 'promotionCodeErrorMessage' },
        _react2.default.createElement(
          _FormInput.Label,
          { htmlFor: name, className: 'a-label a-label--error' },
          this.props.flash.message
        )
      );
    }
  }, {
    key: 'renderPromotionDisplay',
    value: function renderPromotionDisplay() {
      var _context;

      return _react2.default.createElement(
        'p',
        { styleName: 'promotionCode__message' },
        _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'spree.amount_discount_applied',
          amount: Money.format(this.props.amount, this.props.currency, this.props.config.store)
        }),
        _react2.default.createElement(
          'a',
          {
            styleName: 'promotionCode__remove',
            href: '/checkout/remove_coupon_code',
            onClick: (_context = this.props).onRemove.bind(_context),
            title: 'remove'
          },
          '\xA0'
        )
      );
    }
  }, {
    key: 'renderPromotionInput',
    value: function renderPromotionInput() {
      var _context2;

      var _props = this.props,
          t = _props.t,
          flash = _props.flash;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { styleName: 'promotionCode__title', className: 't-text' },
          t('spree.have_a_discount_code')
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'm-inline-input-form' },
          _react2.default.createElement(_FormInput.Input, {
            type: 'text',
            name: 'order[coupon_code]',
            additionalStyles: this.additionalStyles(),
            placeholder: t('spree.enter_code'),
            onReturn: this.handleInputReturn.bind(this),
            onChange: this.handleInputChange.bind(this)
          }),
          _react2.default.createElement(
            _FormInput.Button,
            {
              weight: 'secondary',
              inline: true,
              disabled: this.state.applyCouponButtonDisabled,
              onClick: (_context2 = this.props).onApply.bind(_context2)
            },
            t('spree.apply')
          )
        ),
        flash.message && !flash.messages && this.renderError('order[coupon_code]')
      );
    }
  }, {
    key: 'renderPromotionPlaceholder',
    value: function renderPromotionPlaceholder() {
      return _react2.default.createElement(
        'p',
        { styleName: 'promotionCode__title', className: 't-text' },
        this.props.t('spree.enter_discount_code_in_next_step')
      );
    }
  }, {
    key: 'renderPromotion',
    value: function renderPromotion() {
      if (this.props.amount) {
        return this.renderPromotionDisplay();
      }

      return this.renderPromotionInput();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          step = _props2.step,
          config = _props2.config;


      if (step === 'address' && config.store.disablePromotionsOnAddress) {
        return _react2.default.createElement(
          'div',
          { styleName: 'promotionCode' },
          this.renderPromotionPlaceholder(),
          _react2.default.createElement(
            'div',
            { styleName: 'promotionCode__disabled' },
            this.renderPromotion()
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'promotionCode' },
        this.renderPromotion()
      );
    }
  }]);
  return PromotionCode;
}(_react2.default.Component), _class2.propTypes = {
  currency: _react.PropTypes.string.isRequired,
  amount: _react.PropTypes.any,
  orderNumber: _react.PropTypes.string,
  step: _react.PropTypes.string,
  onRemove: _react.PropTypes.func,
  onApply: _react.PropTypes.func
}, _class2.defaultProps = {
  onRemove: function onRemove() {},
  onApply: function onApply() {}
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = PromotionCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PromotionCode/index.js
// module id = 2499
// module chunks = 0